import {
    Button,
    createStyles,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    WithStyles,
    withStyles,
} from '@material-ui/core';
import _ from 'lodash';
import { inject } from 'mobx-react';
import * as React from 'react';
import { IAffinityCluster, IObservation } from 'src/Definitions';
import { IStores } from 'src/Stores';

const styles = () => createStyles({});

interface IDeleteAffinityClusterDialogProps extends WithStyles<typeof styles> {
    affinityCluster?: IAffinityCluster;
    close?: () => void;
    getAllAffinityClusters?: (assessmentId: string) => Promise<void>;
    isOpen?: boolean;
    undo?: (observation: IObservation) => void;
    updateState: (shouldReloadObservations: boolean) => void;
    disableAffinityCluster?: (affinityCluster: IAffinityCluster) => Promise<void>;
    saveObservation?: (observation: IObservation) => Promise<void>;
}

class DeleteAffinityClusterDialog extends React.Component<IDeleteAffinityClusterDialogProps> {
    public state = {};

    public deleteCluster = () => {
        this.props.affinityCluster!.observations!.forEach((o) => {
            o.affinityClusterId = undefined;
            this.props.saveObservation!((o as unknown) as IObservation);
        });
        this.props.affinityCluster!.observations = [];
        this.props.close!();
        if (this.props.affinityCluster && this.props.affinityCluster.assessmentId) {
            this.props.disableAffinityCluster!(this.props.affinityCluster).then(() => {
                this.props.getAllAffinityClusters!(this.props.affinityCluster!.assessmentId!);
                this.props.updateState(true);
            });
        }
    };

    public render() {
        const { affinityCluster, isOpen, close } = this.props;
        return (
            <Dialog open={isOpen || true} maxWidth="lg" onClose={close}>
                <DialogTitle>{affinityCluster!.name}</DialogTitle>
                <DialogContent>
                    Are you sure you want to delete this affinity cluster?
                </DialogContent>
                <Grid container direction="row" justify="flex-end">
                    <Grid item xs={3}>
                        <Button onClick={this.deleteCluster}>Delete</Button>
                    </Grid>
                    <Grid item xs={3}>
                        <Button onClick={close} data-cy="close">
                            Cancel
                        </Button>
                    </Grid>
                </Grid>
            </Dialog>
        );
    }
}

const InjectedDeleteAffinityClusterDialog = inject<
    IStores,
    IDeleteAffinityClusterDialogProps,
    Partial<IDeleteAffinityClusterDialogProps>,
    any
>((stores: IStores) => ({
    close: stores.affinityClusters.closeDeleteDialog,
    disableAffinityCluster: stores.affinityClusters.disableAffinityCluster,
    getAllAffinityClusters: stores.affinityClusters.getAllAffinityClusters,
    isOpen: stores.affinityClusters.isDeleteModalOpen,
    saveObservation: stores.observations.saveObservation,
}))(withStyles(styles)(DeleteAffinityClusterDialog));

export default InjectedDeleteAffinityClusterDialog;



// WEBPACK FOOTER //
// ./src/affinityClusters/DeleteAffinityClusterDialog.tsx